import type { ModelSchema } from '@ember-data/store/types';
import dayjs from 'dayjs';
import ApplicationSerializer from 'lumen/serializers/application';

interface DataStatusDetailPayload {
  status: string;
  timestamp: string;
}

export default class MarketPerformanceDataStatusSerializer extends ApplicationSerializer {
  attrs = {
    subscription: 'subscription_id',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data-statuses') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('market-performance/data-status');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalize(modelClass: ModelSchema, payload: Record<string, unknown>) {
    // One status per subscription, so the subscription id doubles as the id.
    // Not via primaryKey: the attrs mapping consumes subscription_id first.
    const hash: Record<string, unknown> = {
      ...payload,
      id: payload['subscription_id'],
    };

    // Transforms don't run on nested JSON attrs, so parse the timestamps here
    for (const key of ['reservation', 'summary']) {
      const detail = hash[key] as DataStatusDetailPayload | null | undefined;

      if (detail) {
        hash[key] = { ...detail, timestamp: dayjs(detail.timestamp) };
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
    return super.normalize(modelClass, hash);
  }
}
